import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgStyle } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnchorButtonComponent, ButtonComponent, RiveAnimationDirective, SbDialogSharedModule } from '@sb/ui';

import {
  FooterAction,
  OnboardingDialogData,
  OnboardingDialogResult,
  OnboardingDialogStep,
} from './onboarding-dialog.model';

@Component({
  selector: 'onboarding-dialog',
  standalone: true,
  imports: [
    NgStyle,
    SbDialogSharedModule,
    ButtonComponent,
    AnchorButtonComponent,
    TranslateModule,
    RiveAnimationDirective,
  ],
  templateUrl: './onboarding-dialog.component.html',
})
export class OnboardingDialogComponent implements OnInit {
  public title: string;
  public assetPath: string;
  public isAnimation = false;
  public primary: string;
  public secondary: FooterAction;
  public OnboardingDialogStep = OnboardingDialogStep;

  public constructor(
    public dialogRef: DialogRef<OnboardingDialogResult>,
    @Inject(DIALOG_DATA) public readonly data: OnboardingDialogData,
    private translate: TranslateService,
  ) {}

  public ngOnInit(): void {
    switch (this.data.step) {
      case OnboardingDialogStep.FINISH_INVITED:
        this.title = this.translate.instant("Invites sent! What's next?");
        this.assetPath = '/assets/animations/check-mark.riv';
        this.isAnimation = true;
        this.primary = this.translate.instant('Continue exploring');
        this.secondary = {
          type: 'text',
          text: this.translate.instant('Quick Start Guide'),
        };
        break;
      case OnboardingDialogStep.FINISH_INVITES_SKIPPED:
        this.title = this.translate.instant("You're all set! Time to explore Shiftbase.");
        this.assetPath = '/assets/animations/check-mark.riv';
        this.isAnimation = true;
        this.primary = this.translate.instant('Continue exploring');
        this.secondary = {
          type: 'text',
          text: this.translate.instant('Quick Start Guide'),
        };
        break;
    }
  }

  public onPrimaryClick() {
    this.dialogRef.close({ action: 'primary' });
  }

  public onSecondaryClick() {
    this.dialogRef.close({ action: 'secondary' });
  }
}
